<template>
  <div :class="classes">
    <div v-if="menuItems && menuItems.length > 0" class="box-with-menu__menu">
      <div
        v-for="(item, index) in menuItems"
        :key="index"
        :class="'box-with-menu__menu__item ' + (item.active ? 'box-with-menu__menu__item--active' : '')"
      >
        <m4-button tag="a" variant="default-text" :href="item.url">{{ item.title }}</m4-button>
      </div>
    </div>
    <m4-box v-bind="$attrs" :title="title">
      <template v-slot:righttop v-if="hasRightTopSlot">
        <slot name="righttop"></slot>
      </template>
      <slot></slot>
      <template v-slot:footer v-if="hasFooterSlot">
        <slot name="footer"></slot>
      </template>
      <template v-slot:underfooter v-if="hasUnderFooterSlot">
        <slot name="underfooter"></slot>
      </template>
    </m4-box>
  </div>
</template>

<script>
export default {
  name: "M4BoxWithMenu",
  props: {
    title: String,
    menuItems: Array,
    menuItemAsTab: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  computed: {
    classes() {
      let classes = ["box-with-menu"];
      if (this.menuItemAsTab) {
        classes.push("box-with-menu--tabs");
      }
      if (!this.menuItems || this.menuItems.length === 0) {
        classes.push("box-with-menu--no-menu-items");
      }
      return classes;
    },
    hasBodySlot() {
      return typeof this.$slots.default === "function";
    },
    hasRightTopSlot() {
      return typeof this.$slots.righttop === "function";
    },
    hasFooterSlot() {
      return typeof this.$slots.footer === "function";
    },
    hasUnderFooterSlot() {
      return typeof this.$slots.underfooter === "function";
    }
  }
};
</script>
